import { NodeViewContextableWrapper } from "@ext/markdown/core/element/NodeViewContextableWrapper";
import Alert from "@ext/markdown/elements/alert/render/component/Alert";
import { NodeViewContent, type NodeViewProps } from "@tiptap/react";
import { type ReactElement, useEffect, useRef } from "react";

const EditAlert = (props: NodeViewProps): ReactElement => {
	const { node } = props;
	const hoverElementRef = useRef<HTMLDivElement>(null);

	// ProseMirror ignores edits outside contentDOM, so text typed into the heading would be lost.
	useEffect(() => {
		const heading = hoverElementRef.current?.querySelector<HTMLElement>(".admonition-heading");
		if (heading) heading.contentEditable = "false";
	});

	return (
		<NodeViewContextableWrapper props={props} ref={hoverElementRef}>
			<Alert title={node.attrs.title ?? undefined} type={node.attrs.type}>
				<NodeViewContent />
			</Alert>
		</NodeViewContextableWrapper>
	);
};

export default EditAlert;
